/** zod 校验问题的最小结构。既可以来自本地 `ZodError.issues`,也可以来自
 *  @hono/zod-validator 400 响应体里的 `error.issues`(过了一趟 JSON,故字段可选)。 */
export interface ZodIssueLike {
  path?: (string | number)[];
  message?: string;
}

/**
 * 把 zod 校验问题列成 `字段路径: 原因` 的可读串。
 *
 * 同一份配置既可能被前端在提交前拒绝(RAW JSON 模式),也可能被 worker 用同一个
 * schema 在 PUT 时拒绝 —— 两条路径共用这里,措辞才不会分叉。
 */
export function formatZodIssues(issues: readonly ZodIssueLike[]): string {
  return issues
    .map((i) => `${(i.path ?? []).join('.') || '(根)'}: ${i.message ?? '校验失败'}`)
    .join('; ');
}
